<se-fe-card class="commerce-list-card" id="product-list">
  <se-fe-card-header seFeDataTitle="Products" [seFeDataDivider]="true">
    <div seFeCardHeaderActions>
      <div class="commerce-list-actions__desktop">
        <a
          se-fe-button-low
          [routerLink]="createProductLink()"
          [target]="target()"
          data-testid="add-product-button-product-list-desktop">
          Create product
        </a>
      </div>

      <se-fe-icon-button class="commerce-list-actions__mobile" [seFeMenuTrigger]="mobileMenu">
        <se-fe-icon
          seFeDataName="more_vertical"
          seFeDataSize="900"
          seFeDataAriaLabel="Open product actions menu"></se-fe-icon>
      </se-fe-icon-button>
      <se-fe-menu #mobileMenu [seFeDataOptions]="mobileMenuOptions">
        <div class="se-fe-menu__card-menu-form commerce-list-mobile-menu__actions" seFeMenuContent>
          <a
            se-fe-button-low
            [routerLink]="createProductLink()"
            [target]="target()"
            data-testid="add-product-button-product-list-desktop">
            Create product
          </a>
        </div>
      </se-fe-menu>
    </div>
  </se-fe-card-header>

  <se-fe-card-content>
    <se-fe-grid seFeGridOpts>
      <se-fe-grid-cell seFeGridOpts>
        <product-table
          [mode]="'productList'"
          (queryChanged)="queryChanged($event)"
          (toggleActiveStatus)="toggleActiveStatus($event)"
          [active]="active$ | async"
          [catalogId]="catalogId$ | async"
          [loading]="loading$ | async"
          [products]="products$ | async"
          [paginationEnabled]="true"
          [paginationOptions]="paginationOptions$ | async"
          [showSearch]="true"
          [sortBy]="sortBy$ | async"
          [sortDirection]="sortDirection$ | async"
          [showDelete]="false"
          [query]="queryString$ | async"></product-table>
      </se-fe-grid-cell>
    </se-fe-grid>
  </se-fe-card-content>
</se-fe-card>
